import moment from 'moment';

import callApi from './callApi';
import validateFieldForPlaceholder from './validateFieldPlaceholder';

export const getQueryParams = (query = null) =>
  (query || window.location.search.replace('?', ''))
    .split('&')
    .map((e) => e.split('=').map(decodeURIComponent))
    .reduce((r, [k, v]) => ((r[k] = v), r), {});

export const TRUNCATED_LIMIT = 35;
export const truncatedText = (text, limit = TRUNCATED_LIMIT) => {
  return text.length > limit ? text.slice(0, limit) + '...' : text;
};

// TODO: seems not in use
export function formatDate(date) {
  //  return format
  // 11-16-2022 05:00
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear(),
    hours = '' + d.getHours(),
    minutes = '' + d.getMinutes();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  if (hours.length < 2) hours = '0' + hours;
  if (minutes.length < 2) minutes = '0' + minutes;

  return [year, month, day].join('-') + ' ' + [hours, minutes].join(':');
}

export const encodeBase64 = (data) => {
  return btoa(data);
};
export const decodeBase64 = (data) => {
  return atob(data);
};

export const getItemFromLocalStorage = (key: string): string | null => {
  const item = localStorage.getItem(encodeBase64(key));
  if (item != null) return decodeBase64(item);
  else return null;
};

export const isAdminUserLoggedIn = () => {
  const approle = getItemFromLocalStorage('approle') || 'guest';
  return approle === 'admin';
};

/*
  ----------------------------------
  parseDate function
  ----------------------------------
  This function parse the value for DATE type data
  ----------------------------------
  */
export const parseDate = (value) => {
  const formattedDate =
    value && value.length > 0 && moment(value).isValid()
      ? moment(value).format('lll')
      : validateFieldForPlaceholder(null);
  return formattedDate;
};

interface FetchHostsParams {
  baseUrl: string;
  search: string;
  page: number;
  limit: number;
  company_id: number;
  additionalParams?: Record<string, string>;
}

export type OptionType = {
  value: string | number;
  label: string;
};

/*
----------------------------------
fetchHosts function
----------------------------------
This function fetches hosts
----------------------------------
Params:

baseUrl: string

search: string

page: number

limit: number

company_id: number

The API must return a list of results, total count.

Sample API response:

{
  "count": 2,
  "results": [
    {
      "id": 1,
      "name": "host1"
    },
    {
      "id": 2,
      "name": "host2"
    }
  ]
}
*/
export const fetchHosts = async ({
  baseUrl,
  search,
  limit,
  page,
  additionalParams = {},
}: FetchHostsParams) => {
  if (!search) search = '';
  if (page === undefined) page = 0;
  if (!baseUrl) return null;

  let url = `${baseUrl}?&limit=${limit}&search=${search}&offset=${
    page * limit
  }`;

  Object.entries(additionalParams).forEach(([key, value]) => {
    url += `&${key}=${value}`;
  });

  const response = await callApi(url, 'GET', {});
  if (response.status === 200 || response.status === 201) {
    return {
      results: response.data.results,
      hasMore: response.data.count > (page + 1) * limit,
    };
  }

  return {
    results: [],
    hasMore: false,
  };
};

/**
 * Truncate a string to a specified maximum length, adding ellipsis (...) if it exceeds that length.
 *
 * @param {string} text - The text to be truncated.
 * @param {number} [maxLength=30] - The maximum length of the truncated text, default is 30 characters.
 * @returns {string} - The truncated text with ellipsis appended if it exceeds the specified length,
 *                     otherwise returns the original text.
 *
 * @example
 * Basic usage
 * truncateText("This is a long string that needs truncation.");
 * Returns: "This is a long string that nee..."
 *
 * @example
 * Custom maxLength
 * truncateText("This is a long string that needs truncation.", 10);
 * Returns: "This is a..."
 */
export function truncateText(text, maxLength = 30) {
  if (!text) return '';
  return text?.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
}
